import type { GroupLifePlan } from '@/features/quotes/context/group-life-quote.context';
import type { GroupLifeFrontPlan } from '@/services/group-life';

/** Campos de capital/modalidade persistidos no InsureMO (step plan). */
export function planHasPersistedCapitalFields(
  plan?:
    | Pick<
        GroupLifePlan,
        | 'uniformCapital'
        | 'minimumIndividualCapital'
        | 'maximumIndividualCapital'
        | 'numberOfSalaries'
        | 'maximumDpsWaiverCapital'
      >
    | GroupLifeFrontPlan
    | undefined,
): boolean {
  if (!plan) return false;
  return !!(
    plan.uniformCapital ||
    plan.minimumIndividualCapital ||
    plan.maximumIndividualCapital ||
    plan.numberOfSalaries ||
    plan.maximumDpsWaiverCapital
  );
}

export function mapHydratedPlan(d: GroupLifeFrontPlan): GroupLifePlan {
  return {
    modality: d.modality ?? 'UNIFORM',
    uniformCapital: d.uniformCapital,
    numberOfSalaries: d.numberOfSalaries,
    minimumIndividualCapital: d.minimumIndividualCapital,
    maximumIndividualCapital: d.maximumIndividualCapital,
    maximumDpsWaiverCapital: d.maximumDpsWaiverCapital,
    coverages: d.coverages ?? {},
  };
}

/** O back é autoritativo quando já persistiu o plano; rascunho local parcial
 *  (só coberturas via `updateCoverage`) não deve bloquear a hidratação. */
export function shouldApplyHydratedPlan(
  local: GroupLifePlan | undefined,
  remote: GroupLifeFrontPlan,
): boolean {
  if (planHasPersistedCapitalFields(remote)) return true;
  return !local;
}
